import CryptJS from 'crypto-js'

let UUID = require("uuid");
let NodeRSA = require("node-rsa");

class AESUtil {
  /**
   * AES 加密
   * @param _content 待加密内容
   * @param _key aesKey,
   * @param _iv 初始化向量
   * @return 返回经 BASE64 处理之后的密文
   */
  encrypt(_content, _key, _iv) {

    let content = CryptJS.enc.Utf8.parse(_content);
    let aesKey = CryptJS.enc.Utf8.parse(_key);
    let iv = CryptJS.enc.Utf8.parse(_iv);

    // 加密
    let encrypted = CryptJS.AES.encrypt(content, aesKey, {
      iv: iv,
      mode: CryptJS.mode.CBC,
      padding: CryptJS.pad.Pkcs7
    })
    return CryptJS.enc.Base64.stringify(encrypted.ciphertext);
  }

  /**
   * AES 解密
   * @param：_content 待解密的内容[Base64处理过的]
   * @param：解密用的 AES key
   * @param: 初始化向量
   * @return 返回以 UTF-8 处理之后的明文
   */
  decrypt(_content, _key, _iv) {
    let aesKey = CryptJS.enc.Utf8.parse(_key);
    let iv = CryptJS.enc.Utf8.parse(_iv);

    // 解密
    let decrypted = CryptJS.AES.decrypt(_content, aesKey, {
      iv: iv,
      mode: CryptJS.mode.CBC,
      padding: CryptJS.pad.Pkcs7
    })
    return decrypted.toString(CryptJS.enc.Utf8);
  }

  getAesKey() {
    let uuid = UUID.v1();
    let aeskey = CryptJS.enc.Utf8.parse(uuid)
    aeskey = CryptJS.enc.Base64.stringify(aeskey).substring(2, 34)
    return aeskey;
  }

  /**
   * 获得初始化向量
   * @returns 16 字节的初始化向量
   */
  getIv() {
    let uuid = UUID.v1();
    let iv = CryptJS.enc.Utf8.parse(uuid);
    iv = CryptJS.enc.Base64.stringify(iv).substring(2, 18);
    return iv;
  }

  /**
   * 获得 AES key 及 初始化向量 iv
   * 其实 iv 和 aesKey 两者的生成并没有什么关系，两者只是对各自的长度有限制，
   * 这里只是为了方便使用，进行了一个组合返回。
   * @return 返回 iv 和 aesKey 的组合
   */
  getAESKeyAndIv() {
    let aesKeyAndIv = {
      "iv": this.getIv(),
      "aesKey": this.getAesKey(),
    }

    return aesKeyAndIv;
  }
}


class RSAUtil {
  /**
   * 生成 RSA 密钥对
   * @returns 以 PEM 格式返回 公钥与私钥 的组合对象
   */
  getRSAKeyPair() {
    // 生成空对象
    let keyPair = new NodeRSA();
    keyPair.setOptions({
      encryptionScheme: "pkcs1"
    })
    // keyPairObj, 保存经 BASE64 编码处理之后 PEM 格式的 RSA 密钥对
    let keyPairObj = {
      publicKey: '',
      privateKey: ''
    };
    keyPair.generateKeyPair(2048, 65537);
    /**
     * 导出密钥，对输出的密钥做一些格式化处理，以便 Java 端能直接使用，算然经过处理但是并不影响 JS 端的密钥导入，及正确性。
     * 1. 公钥
     * 2. 私钥
     */
    keyPairObj.publicKey = keyPair.exportKey("pkcs8-public-pem").replace(/-----BEGIN PUBLIC KEY-----/, '').replace(/-----END PUBLIC KEY-----/, '').replace(/\n/g, '');
    keyPairObj.privateKey = keyPair.exportKey("pkcs8-private-pem").replace(/-----BEGIN PRIVATE KEY-----/, '').replace(/-----END PRIVATE KEY-----/, '').replace(/\n/g, '');

    return keyPairObj;
  }

  /**
   * 公钥加密，加密之后以 BASE64 形式编码
   * @param buffer : 待加密内容 编码格式：utf-8
   * @param publicKey: 加密使用的公钥, 格式是：pkcs8 pem
   * @param encoding: 加密之后的输出编码类型 默认输出编码格式是：base64
   * @param source_encoding: 指定代加密内容的编码方式，默认是：utf-8
   * @returns: 返回以 BASE64 处理之后的加密内容
   */
  publicKeyEncrypt(buffer, pubicKey, encoding = "base64", source_encoding = "utf8") {
    // 导入 publickey
    let key = new NodeRSA();
    key.setOptions({
      encryptionScheme: "pkcs1", // 默认是：pkcs1_oaep，Java 端默认是 pkcs1, 这里做个修改
    })
    key.importKey(pubicKey, "pkcs8-public-pem");
    // 加密并返回加密结果
    return key.encrypt(buffer, encoding, source_encoding);
  }

  /**
   * 私钥解密，解密之后 返回 utf8编码的字符串
   * @param buffer: Buffer object or base64 encoded string
   * @param privateKey: 解密用的私钥，格式是：pkcs8 pem
   * @param encoding: 加密之后的类型 buffer OR json, 默认是 buffer
   * @returns：默认返回值类型就是 encoding 的默认值，即 buffer
   */
  privateKeyDecrypt(buffer, privateKey, encoding = "buffer") {
    // 导入 privatekey
    let key = new NodeRSA();
    key.setOptions({
      encryptionScheme: "pkcs1", // 默认是：pkcs1_oaep，Java 端默认是 pkcs1, 这里做个修改
    })
    key.importKey(privateKey, "pkcs8-private-pem");
    // 解密
    return key.decrypt(buffer, encoding);
  }

  pubicKeyDecrypt(buffer, pubicKey, encoding = "buffer") {
    // 导入 pubicKey
    let key = new NodeRSA();
    key.setOptions({
      encryptionScheme: "pkcs1", // 默认是：pkcs1_oaep，Java 端默认是 pkcs1, 这里做个修改
    })

    key.importKey(pubicKey, 'pkcs8-public-pem');
    // 解密
    return key.decryptPublic(buffer, encoding);
  }
}

class encryptionandDecryption {
  constructor() {
    this.keyPair = {
      publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnjZi+0TZRy16pF0aztzWjhGszkUt9yGhXxCdo61xfxwq31Clrjv6Ltgq8TdYOUrwNCEEtd2gFJhl5ggUjVOs0IZPauJ2aahm+OZPnuXQd+I0+jOy8gdRWeHSB4Dwe8nlHcushKoGt8+xWDdHjBdXpC0rumSvOFbBqsHo8tFI7EO1QxbAKvqOLcPoFPMr+9KVyODN/ex5sDmLOjbGWGhBYJgqpe8OEoJgk9Lu5MqdZVLJNdEQ+/M4hrEXGJ37W29n4pA1KspyNG/aF1a4ghFB7WorEUeeIeIwdGBOU9WausbHDSWKBHJk7dig9p6391Ub5lwhe+qSWAh6BwP5N1msvwIDAQAB",
      privateKey: 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCeNmL7RNlHLXqkXRrO3NaOEazORS33IaFfEJ2jrXF/HCrfUKWuO/ou2CrxN1g5SvA0IQS13aAUmGXmCBSNU6zQhk9q4nZpqGb45k+e5dB34jT6M7LyB1FZ4dIHgPB7yeUdy6yEqga3z7FYN0eMF1ekLSu6ZK84VsGqwejy0UjsQ7VDFsAq+o4tw+gU8yv70pXI4M397HmwOYs6NsZYaEFgmCql7w4SgmCT0u7kyp1lUsk10RD78ziGsRcYnftbb2fikDUqynI0b9oXVriCEUHtaisRR54h4jB0YE5T1Zq6xscNJYoEcmTt2KD2nrf3VRvmXCF76pJYCHoHA/k3Way/AgMBAAECggEAbYXIz5jBsPxSwiWRwVIvVPn3XnOVdlbZly2xcvVGdG/TXfQ+PXdXocYTNBjUAhVWYz/YOu3JO3ikUbGWSJ98Kn5Py/YpcssZPYRx6dW9ksANXIcdgV5/enFRK9CeqZMCALZWHyB0thoY8rCR3vDpwsViWA4LHj0wpDzIPg+TI7pDCtQf+u5MUDrs1pXReWCEqK0Woy8AlTDZMjKZGtaW/Vf+w5qcIPS6/FzjsR4BvgUdoBjTMvU4JtMsd3Lq0xb5wo1r/s01F/BcJkzn04krh5BEPkdjHsHcIeS2izEXlE4ib0XDj9Ll5KLmC/gRYsOw6xPOwuA2TCtfQZXkUEdBAQKBgQDg9PUgHewUE16oX1S+Cj1tAmA+OeAUooYypgQ7Kq3771fsvimQ11mwS2dWAHHmzeOPvzsh90Bb6QCiy4oA5uM7U3s0mXZxXm3+UmVez+Xy7oxqev+JDmMbhYtgMSa0p+uJ17381ZI8QHNpanqWFn8ssRWXbN1t1Qw2QRcv3cTIzwKBgQC0C406Tm6LFbR9UdcVEFAl+EiuAmcb2tFIwxQZb3S+Cht5HH1PB99yNN/h8WIKn4V1ePyofDtxm1K4lgfpoOl0ga3ziwBg3naSjn7hho5yERUHmoEiRKC9yazXeYnSUPCCEJFKs99b9hHHjn/JEWzHLJTlNTO7fJxot2fD2ln5EQKBgQCEz5o4z/GlGJp2BXJekGUbip+PnVOyWxGnrWQqGlSFvRTH7K1Vmg6Viq8Dk1er0Dpdj6U1tGgG21VIx6o+RhI54FuI/mFzJTEDSVoX094KwtObuepL3HaetQVIUTxsxAbHZtv//YdMkzCQOBEPs1B57kK1F8zTH0kKbvtlgyS++QKBgF56KVPNUGifrSSNy4V8F/K0xL66+Aw/2M6Lv4JRYDtQ5nW5I3BTO0ecw1a26bGVX9zy7fIjrrXAwbmm0OQh0h+W5QcFi99JHYNuTtpdV2Y33Icu5lBrHsY4jABOAKpiWrKFqxg+JxkEmPPUrO1/vUsO89sK/eiGTTUN+N9nNwthAoGAb149PFrESs3aAn+KpmJ6GtWOCoMi3Nv9OSsIJbeIF9o19M3tQ/phi3YNg0e7rXEi7GRG0OroUeRiDe/QQQx+K2qDg90aoeWGuYRxytCtYtuxYXg2X2eOHKrTHEmBcuij/5IJ4RLoMUaS+lbFqdbVRXQ1JACSgLtN7AIxBZIt0XE='
    }
    this.keyAes = {
      iv: "0000000000000000",
      aesKey: 'DKJIANKSDLLASDOI',
      encrypted: "",
    }
  }

  solution(params) {
    let keyPair = this.keyPair;
    let encrypted1 = params.lock
    let dencrypted1 = new RSAUtil().pubicKeyDecrypt(encrypted1, keyPair.publicKey);
    let keyAes = this.keyAes
    keyAes.aesKey = dencrypted1.toString('utf8')
    keyAes.encrypted = params.data
    let decrypted = new AESUtil().decrypt(keyAes.encrypted, keyAes.aesKey, keyAes.iv);
    return JSON.parse(decrypted)
  }

  plus(options) {
    let content = JSON.stringify(options)
    let keyAes = this.keyAes
    let encrypted = new AESUtil().encrypt(content, keyAes.aesKey, keyAes.iv);
    let keyPair = this.keyPair;
    let lock = new RSAUtil().publicKeyEncrypt(keyAes.aesKey, keyPair.publicKey);
    return {lock: lock, data: encrypted, time: Date.parse(new Date())}
  }

  privateKeyConte(params) {
    let keyPair = this.keyPair;
    let dencrypted = new RSAUtil().privateKeyDecrypt(params.lock, keyPair.privateKey);
    let keyAes = this.keyAes
    keyAes.aesKey = dencrypted.toString('utf8')
    keyAes.encrypted = params.data

// eslint-disable-next-line
    let decrypted = new AESUtil().decrypt(keyAes.encrypted, keyAes.aesKey, keyAes.iv);
  }

}

//
export const solution = (params) => new encryptionandDecryption().solution(params);
export const plus = (params) => new encryptionandDecryption().plus(params);


export const privateKeyConte = (params) => new encryptionandDecryption().privateKeyConte(params);


export {
  AESUtil,
  RSAUtil
}

